import { OptionsObject, enqueueSnackbar } from 'notistack';

export const showSnackBar = (text: string, options: OptionsObject) => {
	enqueueSnackbar(text, { ...options });
};
